import React, {Component} from 'react';
import './Default.css'
import objeler from '../objeler';

class Barcode extends Component {
    constructor(props) {
        super(props);
        const {JpgBlob} = this.props;
        const inputRef = React.createRef(null);
        this.imgOnLoad = this.imgOnLoad.bind(this)
        this.imgRef = React.createRef();
    };

    componentDidMount() {
    }

    imgOnLoad() {
        const height = this.imgRef.current.naturalHeight
        const width = this.imgRef.current.naturalWidth
        const ElementProps = objeler['ElementProps'];
        ElementProps.JpgOriginalWidth = width;
        ElementProps.JpgOriginalHeight = height;
        ElementProps.JpgOriginalAspectRatio = width / height;
        const {pictureOnLoad} = this.props;
        pictureOnLoad(ElementProps);
    }

    render() {
        const {file, content, type} = this.props;
        const imgstyle = {
            backgroundImage: `url(images/${this.props.BarcodeType == 'QR' ? 'qr_TR.gif' : this.props.BarcodeType == 'EAN128' ? 'code128l_TR.gif' : 'i25l_TR.gif'})`,
            backgroundSize: '100% 100%',
            backgroundPosition: 'center',
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%',
            backgroundColor: this.props.Color
        };
        return (
            <React.Fragment>
                {type}
                <div id="tar" ref="tar"
                     style={imgstyle}
                >
                    <img ref={this.imgRef} onLoad={this.imgOnLoad}
                         style={{visibility: 'hidden'}}
                         src={file}></img>
                </div>
            </React.Fragment>
        );
    }
}

export default Barcode;